import { render, staticRenderFns } from "./gestionFactureCommerciaux.vue?vue&type=template&id=2066eae0&scoped=true&"
import script from "./gestionFactureCommerciaux.vue?vue&type=script&lang=js&"
export * from "./gestionFactureCommerciaux.vue?vue&type=script&lang=js&"
import style0 from "./gestionFactureCommerciaux.vue?vue&type=style&index=0&id=2066eae0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2066eae0",
  null
  
)

export default component.exports